import {AxiosResponse} from 'axios';
import {apiClient} from '../apiClient';

const BASE_URL = 'permissions/api/v1';

export interface SecurityGroup {
  id: number;
  securityGroupName: string;
}

export interface AddSecurityGroupRequest {
  securityGroupName: string;
}

export interface UpdateSecurityGroupRequest {
  securityGroupID: number;
  securityGroupName: string;
}

export interface UpdateAnalyticStatusRequest {
  securityGroupID: number;
  isInprogress: boolean;
  isSecurityGroupLevel: boolean;
}

export interface AccessControlData {
  securityGroupId: number;
  securityGroupName: string;
  isSecurityGroupLevel: boolean;
}

export const getSecurityGroups = async (): Promise<SecurityGroup[]> => {
  const response = await apiClient.get<SecurityGroup[]>(
    `${BASE_URL}/securitygroups/list`,
    {
      headers: {
        accept: 'application/json',
      },
    }
  );
  return response.data;
};

export const addSecurityGroup = async (
  payload: AddSecurityGroupRequest
): Promise<string> => {
  const response = await apiClient.post<string>(
    `${BASE_URL}/securitygroups/add`,
    payload,
    {
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const updateSecurityGroup = async (
  payload: UpdateSecurityGroupRequest
): Promise<string> => {
  const response = await apiClient.put<string>(
    `${BASE_URL}/securitygroups/update`,
    payload,
    {
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};

export const deleteSecurityGroup = async (
  securityGroupId: number
): Promise<string> => {
  // Use <string> to indicate the expected type of response.data
  const response: AxiosResponse<string> = await apiClient.delete(
    `${BASE_URL}/securitygroups/delete`,
    {
      headers: {
        accept: '*/*',
      },
      params: {
        securityGroupId,
      },
    }
  );

  return response.data || '';
};

export const updateAnalyticSecurityGroupStatus = async (
  payload: UpdateAnalyticStatusRequest
): Promise<string> => {
  const response = await apiClient.post<string>(
    `${BASE_URL}/securitygroups/analytics/status`,
    payload,
    {
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const getSecurityGroupAccessControls = async (
  securityGroupId: number
): Promise<AccessControlData> => {
  const response = await apiClient.get<AccessControlData>(
    `${BASE_URL}/securitygroups/access-controls`,
    {
      headers: {
        accept: 'application/json',
      },
      params: {
        securityGroupId,
      },
    }
  );
  return response.data;
};
